<template>
  <div class="pr-md-24">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'shipmentprofile-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
      <v-form ref="form" @submit.prevent="edit" class="pa-4 px-4">
        <v-row>
          <v-col>
            <div class="text-left mb-6 d-flex justify-space-between">
              <h4 class="back--text gotham-book">General Information</h4>
            </div>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-text-field
              label="Name"
              :rules="nameRules"
              v-model="profile.name"
              outlined
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="profile.method"
              :rules="methodRules"
              :items="methods"
              outlined
              label="Method"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="12" md="6" class="py-0">
            <v-autocomplete
              v-model="profile.countryIds"
              :items="countries"
              outlined
              multiple
              label="Countries"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div class="d-flex justify-start">
          <v-btn type="submit" color="accent" class="font-bold"
            >Update Shipment Profile</v-btn
          >
        </div>
      </v-form>
    </v-card>
    <product-list
      class="mb-5"
      :payload="{ from: 0, to: 10, shipmentProfileId: id }"
      :showFilters="false"
    />
    <shipment-profile-rate-list
      @add="showShipmentRateDialog = true"
      :payload="{ from: 0, to: 0, shipmentProfileId: id }"
    />
    <v-dialog v-model="showShipmentRateDialog" width="800">
      <v-form
        ref="shipmentrateform"
        @submit.prevent="createShipmentProfileRate"
      >
        <v-card class="px-10 py-10">
          <v-row class="mb-2">
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Name"
                :rules="rate.nameRules"
                v-model="shipmentProfileRate.name"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Cost"
                :rules="rate.costRules"
                type="number"
                v-model="shipmentProfileRate.cost"
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Min Price"
                :rules="rate.minPriceRule"
                type="number"
                v-model="shipmentProfileRate.minPrice"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Max Price"
                :rules="rate.maxPriceRule"
                type="number"
                v-model="shipmentProfileRate.maxPrice"
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Min Weight"
                :rules="rate.minWeightRule"
                type="number"
                v-model="shipmentProfileRate.minWeight"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                label="Max Weight"
                :rules="rate.maxWeightRule"
                type="number"
                v-model="shipmentProfileRate.maxWeight"
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-start">
            <v-btn type="submit" color="accent" class="font-bold"
              >Create Shipment Rate</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ProductList from "@/components/product_management/ProductList.vue";
import ShipmentProfileRateList from "@/components/shipment_profile_management/ShipmentProfileRateList.vue";
export default {
  props: ["id"],
  components: {
    ProductList,
    ShipmentProfileRateList
  },
  data() {
    return {
      showShipmentRateDialog: false,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 4) || "Name must be at least 4 characters",
        v =>
          (v && v.length <= 250) || "Name must be less than than 250 characters"
      ],
      methodRules: [v => !!v || "Method is required"],
      methods: [
        { text: "Weight Based", value: "weight_based" },
        { text: "Price Based", value: "price_based" },
        { text: "Fixed Price", value: "fixed_price" }
      ],
      rate: {
        nameRules: [
          v => !!v || "Name is required",
          v => (v && v.length >= 4) || "Name must be at least 4 characters",
          v =>
            (v && v.length <= 250) ||
            "Name must be less than than 250 characters"
        ],
        costRules: [
          v => !!v || "Cost is required",
          v =>
            /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
            "Cost must be decimal number with two decimal number maximum",
          v => (v && v >= 1) || "Cost must be at least 1",
          v => (v && v <= 99999.99) || "Cost must be less then 99999.99"
        ],
        minPrice: [
          v =>
            /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
            "Minimum price must be decimal number with two decimal number maximum",
          v => (v && v >= 1) || "Minimum price must be at least 1",
          v =>
            (v && v <= 99999.99) || "Minimum price must be less then 99999.99"
        ],
        maxPrice: [
          v =>
            /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
            "Maximum price must be decimal number with two decimal number maximum",
          v => (v && v >= 1) || "Maximum price must be at least 1",
          v =>
            (v && v <= 99999.99) || "Maximum price must be less then 99999.99"
        ],
        minWeight: [
          v =>
            /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
            "Minimum weight must be decimal number with two decimal number maximum",
          v => (v && v >= 1) || "Minimum weight must be at least 1",
          v =>
            (v && v <= 99999.99) || "Minimum weight must be less then 99999.99"
        ],
        maxWeight: [
          v =>
            /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
            "Maximum weight must be decimal number with two decimal number maximum",
          v => (v && v >= 1) || "Maximum weight must be at least 1",
          v =>
            (v && v <= 99999.99) || "Maximum weight must be less then 99999.99"
        ]
      }
    };
  },
  computed: {
    ...mapState({
      shipmentProfileRate: state =>
        state.shipmentprofilerates.shipmentProfileRate,
      profile: state => state.shipmentprofiles.profile,
      countries: state => state.countries.countries
    })
  },
  mounted() {
    this.$store.dispatch("shipmentprofiles/LOAD_SHIPMENT_PROFILE", this.id);
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
  },
  methods: {
    async createShipmentProfileRate() {
      if (this.$refs.shipmentrateform.validate()) {
        this.showShipmentRateDialog = false;
        this.$swal({
          title: "Create Shipment Profile Rate",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "shipmentprofilerates/CREATE_SHIPMENT_PROFILE_RATE",
          {
            id: this.id,
            shipmentProfileRate: this.shipmentProfileRate
          }
        );
        await this.$swal({
          title: "Success",
          html: "Shipment Profile rate has been created",
          icon: "info"
        });
      }
    },
    async edit() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating shipment profile...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch(
          "shipmentprofiles/UPDATE_SHIPMENT_PROFILE",
          this.profile
        );
        this.$swal({
          title: "Success",
          html: "Shipment Profile has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
